import React, { useEffect, useState, useRef } from 'react';
import Slider from "react-slick";
import { Link, NavLink } from 'react-router-dom';
import { recentproductList, productDetails } from '../services/Product-service';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Loader from "./Loader";
import { formatPrice } from "../utils/formatPrice";
import { BsHeart, BsHeartFill } from "react-icons/bs";
import LoginModal from "./loginmodal";
import { addWishList, removeWishList } from "../services/User-service";
import { useDispatch, useSelector } from "react-redux";
import { getWishListd } from "../Redux/features/wishlist/WishListSlice";
import { toast } from "react-toastify";

function Recently({ showrecentviewed, className, sectionTitle, onProductNavigate }) {
    const handleProductNavigate = (e) => {
        if (typeof onProductNavigate === "function") {
            // Let Link update the route, then close search without restoring old scroll
            onProductNavigate();
            requestAnimationFrame(() => {
                try { window.scrollTo(0, 0); } catch (err) { /* ignore */ }
            });
        }
    };
    const dispatch = useDispatch();
    const sliderRef = useRef(null);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [showLogin, setShowLogin] = useState(false);
    const [wishlistLoadingId, setWishlistLoadingId] = useState(null);
    const userInfo = useSelector((state) => state.user?.userInfo);
    const wishlist = useSelector((state) => state.wishlist);

    const isProductInWishlist = (productId) => {
        if (wishlist?.wishlistItems && wishlist.wishlistItems.length > 0) {
            return wishlist.wishlistItems.some(
                (item) => item.product_id === productId || item.id === productId
            );
        }
        return false;
    };

    const handleWishlistClick = async (e, productId) => {
        e.preventDefault();
        e.stopPropagation();
        if (!userInfo) {
            setShowLogin(true);
            return;
        }
        if (wishlistLoadingId) return;
        const userDetails = {
            product_id: productId,
            user_id: userInfo?.data?.user?.id,
        };
        setWishlistLoadingId(productId);
        try {
            if (isProductInWishlist(productId)) {
                const data = await removeWishList(userDetails);
                if (data.status) {
                    await dispatch(getWishListd(userDetails));
                    toast.success("Removed from wishlist!", { position: "bottom-right" });
                }
            } else {
                const data = await addWishList(userDetails);
                if (data.status) {
                    await dispatch(getWishListd(userDetails));
                    toast.success("Product added to wish list successful...", {
                        position: "bottom-right",
                    });
                }
            }
        } catch (error) {
            console.error("Wishlist error:", error);
            toast.error("Failed to update wishlist", { position: "bottom-right" });
        } finally {
            setWishlistLoadingId(null);
        }
    };

    // Custom Prev Arrow
    const CustomPrevArrow = ({ className, style, onClick, isDisabled }) => (
        <button
            className={className}
            style={{
                ...style,
                display: isDisabled ? "none" : "block", // Hide arrow if disabled
            }}
            onClick={!isDisabled ? onClick : null}
        />
    );

    // Custom Next Arrow (Optional)
    const CustomNextArrow = ({ className, style, onClick }) => (
        <button className={className} style={{ ...style }} onClick={onClick} />
    );

    const recentproductArr = useSelector((state) => state.products.recentlyViewed);

    const [lowestPrices, setLowestPrices] = useState({});

    useEffect(() => {
        if (!recentproductArr || recentproductArr.length === 0) return;

        recentproductArr.forEach((product) => {
            const prodId = product.id;
            if (prodId && lowestPrices[prodId] === undefined) {
                // Initialize to prevent duplicate fetches
                setLowestPrices((prev) => ({ ...prev, [prodId]: null }));

                productDetails(prodId)
                    .then((data) => {
                        if (data && data.productvariants && data.productvariants.length > 0) {
                            const sizeOrder = ['3xs', 'xxs', 'xs', 's', 'm', 'l', 'xl', '2xl', 'xxl', '3xl', 'xxxl', '4xl', '5xl', '6xl'];
                            const sortedVars = [...data.productvariants].sort((a, b) => {
                                const sizeA = (a.size || '').toLowerCase().trim();
                                const sizeB = (b.size || '').toLowerCase().trim();
                                const indexA = sizeOrder.indexOf(sizeA);
                                const indexB = sizeOrder.indexOf(sizeB);
                                if (indexA === -1 && indexB === -1) return 0;
                                if (indexA === -1) return 1;
                                if (indexB === -1) return -1;
                                return indexA - indexB;
                            });
                            const lowestVariant = sortedVars[0];
                            if (lowestVariant) {
                                setLowestPrices((prev) => ({
                                    ...prev,
                                    [prodId]: {
                                        price: Number(lowestVariant.price) || 0,
                                        saleprice: Number(lowestVariant.saleprice) || 0
                                    }
                                }));
                            } else {
                                setLowestPrices((prev) => ({
                                    ...prev,
                                    [prodId]: {
                                        price: Number(product.price) || 0,
                                        saleprice: Number(product.saleprice) || 0
                                    }
                                }));
                            }
                        } else {
                            setLowestPrices((prev) => ({
                                ...prev,
                                [prodId]: {
                                    price: Number(product.price) || 0,
                                    saleprice: Number(product.saleprice) || 0
                                }
                            }));
                        }
                    })
                    .catch((err) => {
                        console.error(`Error fetching lowest price for product ${prodId}`, err);
                        setLowestPrices((prev) => ({
                            ...prev,
                            [prodId]: {
                                price: Number(product.price) || 0,
                                saleprice: Number(product.saleprice) || 0
                            }
                        }));
                    });
            }
        });
    }, [recentproductArr]);

    const totalItems = Array.isArray(recentproductArr) ? recentproductArr.length : 0;
    const desktopSlidesToShow = 5;
    const tabletSlidesToShow = 2;
    const mobileSlidesToShow = 2;

    var settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: desktopSlidesToShow,
        slidesToScroll: totalItems > desktopSlidesToShow ? desktopSlidesToShow : 1,
        initialSlide: 0,
        swipe: true,
        swipeToSlide: true,
        touchMove: true,

        beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
        prevArrow: <CustomPrevArrow isDisabled={currentSlide === 0} />,
        nextArrow: <CustomNextArrow />,


        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    dots: false,
                    infinite: false,
                    slidesToShow: desktopSlidesToShow,
                    slidesToScroll: totalItems > desktopSlidesToShow ? desktopSlidesToShow : 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    dots: false,
                    infinite: false,
                    slidesToShow: tabletSlidesToShow,
                    slidesToScroll: totalItems > tabletSlidesToShow ? tabletSlidesToShow : 1,
                    initialSlide: 0
                }
            },
            {
                breakpoint: 480,
                settings: {
                    dots: false,
                    infinite: false,
                    slidesToShow: mobileSlidesToShow,
                    slidesToScroll: totalItems > mobileSlidesToShow ? mobileSlidesToShow : 1,
                    arrows: false,
                    initialSlide: 0
                }
            },
        ]
    };

    // Search modal / delayed layout can park slick slides off-screen — re-center after mount
    useEffect(() => {
        if (!showrecentviewed || totalItems === 0) return undefined;
        const refresh = () => {
            const slider = sliderRef.current;
            if (!slider) return;
            try {
                if (typeof slider.slickGoTo === 'function') slider.slickGoTo(0, true);
            } catch (e) {
                // ignore
            }
            window.dispatchEvent(new Event('resize'));
        };
        const t1 = window.setTimeout(refresh, 60);
        const t2 = window.setTimeout(refresh, 250);
        return () => {
            window.clearTimeout(t1);
            window.clearTimeout(t2);
        };
    }, [showrecentviewed, totalItems, lowestPrices]);

    return (
        showrecentviewed && totalItems > 0 && (
        <>
            <div className={className || ""}>
                <div className='App HomeSection'>
                    <div className="BreakPointContainer">
                        <div className="CarouselSectionContainer CarouselOneSectionContainer">
                            <div className="layout row justify-space-between align-center text-left SectionTitle">
                                <h1 className='m-t-0 m-b-0 demi-bold w-auto'> {sectionTitle || 'RECENTLY VIEWED PRODUCTS'} </h1>
                                <NavLink to="/category?view=recently" onClick={handleProductNavigate} className='ViewAllUrlsLink orat-color-hover h5 demi-bold w-auto'>VIEW ALL</NavLink>
                            </div>
                            <div className="slider-container recently-viewed-slider">
                                <Slider ref={sliderRef} key={Object.keys(lowestPrices).length} {...settings}>
                                    {recentproductArr?.map((data, index) => (
                                        <div className='item' key={index}>
                                            <div className="CarouselSection product">
                                                <div className="prel Gutter">

                                                    <Link to={`/products/productdetails/${data.id}`} onClick={handleProductNavigate}>
                                                        {/* <div className="DynamicHeightLoaderWrapper" style={{ paddingTop: '130%', overflow: 'hidden' }} >
                                                            <div className="DynamicHeightLoader layout row align-center justify-center" style={{ paddingTop: '20%' }}>
                                                                <img src={data.product_thumbail} alt={data.product_title} className='img-resp DynamicHeightLoaderImage' style={{ padding: '0px' }} />

                                                            </div>
                                                            <div className="animated-bg-placeholder"></div>
                                                        </div> */}
                                                        <div className="DynamicHeightLoaderWrapper" style={{ paddingTop: '130%', overflow: 'hidden', position: 'relative' }} >
  <div className="DynamicHeightLoader layout row align-center justify-center" style={{ paddingTop: '20%' }}>
    <img src={data.product_thumbail} alt={data.product_title} className='img-resp DynamicHeightLoaderImage' style={{ padding: '0px' }} />
  </div>
  <button
      type="button"
      className={`btn-icon product-wishlist-heart${isProductInWishlist(data.id) ? ' is-active' : ''}${wishlistLoadingId === data.id ? ' is-loading' : ''}`}
      onClick={(e) => handleWishlistClick(e, data.id)}
      disabled={wishlistLoadingId === data.id}
      aria-label="Wishlist"
      aria-busy={wishlistLoadingId === data.id}
    >
      {wishlistLoadingId === data.id ? (
        <span className="wishlist-heart-spinner" aria-hidden="true" />
      ) : isProductInWishlist(data.id) ? (
        <BsHeartFill className="is-wishlisted" />
      ) : (
        <BsHeart />
      )}
    </button>
  <div className="animated-bg-placeholder"></div>
</div>
                                                        {/* <div className="image-gradient"></div> */}
                                                        <div className="ImageTextDetail ProductImageTextDetail">
                                                            <label className="ellipsis h5 ImageTextLabelTop m-t-5 demi-bold"> {data.product_title} </label>
                                                             <label className="h6 ellipsis-two-line font-normal ImageTextLabelBottom block font-normal">{data.product_short_description}</label>
                                                             <div className="ProductPrice layout row wrap">
                                                                 {(() => {
                                                                     const lowestInfo = lowestPrices[data.id];
                                                                     const finalPrice = lowestInfo 
                                                                         ? (lowestInfo.saleprice > 0 ? lowestInfo.saleprice : lowestInfo.price)
                                                                         : (data?.saleprice > 0 ? data.saleprice : data.price);
                                                                     return (
                                                                         <span className='SpecialPrice p2 demi-bold w-auto p-0 detail_spc' style={{ marginLeft: '5%' }}>
                                                                             ₹{formatPrice(finalPrice, { showSymbol: false })}
                                                                         </span>
                                                                     );
                                                                 })()}
                                                                {data?.discount_amount > 0 && (<span className='InitialPrice p3 w-auto p-0'> ₹{formatPrice(data?.price, { showSymbol: false })} </span>)}
                                                                <span className='DiscountPriceRound p3 w-auto p-0'>
                                                                    {data?.discount_type == 'flat' ? `${data?.discount_amount} FLAT OFF` : ''}
                                                                    {data?.discount_type == 'percentage' ? `${data?.discount_amount}% OFF` : ''} </span>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    ))}

                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <LoginModal showModal={showLogin} modalHide={() => setShowLogin(false)} />
        </>
        )
    )
}

export default Recently;